import { fromJS, Record } from 'immutable';
import { CompanyInfo } from './sub-models/company-info.model';
import { generateKeys, generateSchema, setInModel } from 'i2g-ng-utils';

const SCHEMA = Object.freeze({
  COMPANY_INFO: CompanyInfo,
  REFERRAL_CODE: '',
});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class Referer extends Record(RECORD) {
  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.COMPANY_INFO,
        value: new CompanyInfo(this.companyInfo),
      },
    ]) as Referer;
  }

  get companyInfo(): CompanyInfo {
    return this.get(KEYS.COMPANY_INFO);
  }

  get email(): string {
    return this.companyInfo.email;
  }

  get name(): string {
    return this.companyInfo.name;
  }

  get referralCode(): string {
    return this.get(KEYS.REFERRAL_CODE);
  }
}
